var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPresentationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    filter: "url(#filter0_d_1285_645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_4_Presentation"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63.7926 15.0319V50.1881C63.7926 56.384 58.7697 61.4069 52.5738 61.4069H17.4258C11.2299 61.4069 6.20703 56.384 6.20703 50.1881V15.0319C6.20703 8.83597 11.2299 3.81311 17.4258 3.81311H52.5739C58.7698 3.81311 63.7926 8.83597 63.7926 15.0319Z",
    fill: "white",
    stroke: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M49.9619 29.8737H48.9131V14.4459H49.9619C50.29 14.4459 50.5479 14.1823 50.5479 13.86C50.5479 13.5377 50.29 13.274 49.9619 13.274H20.0322C19.71 13.274 19.4463 13.5377 19.4463 13.86C19.4463 14.1823 19.71 14.4459 20.0322 14.4459H21.0811V29.8737H20.0322C19.71 29.8737 19.4463 30.1315 19.4463 30.4596C19.4463 30.7819 19.71 31.0455 20.0322 31.0455H33.5029L27.3916 37.0865C27.1572 37.3151 27.1572 37.6901 27.3857 37.9186C27.6143 38.1471 27.9834 38.153 28.2119 37.9244L34.9971 31.2096L41.7822 37.9244C42.0107 38.1471 42.3857 38.1471 42.6084 37.9186C42.8369 37.6901 42.8369 37.3151 42.6084 37.0865L36.4912 31.0455H49.9619C50.29 31.0455 50.5479 30.7819 50.5479 30.4596C50.5479 30.1315 50.29 29.8737 49.9619 29.8737ZM47.7412 29.8737C37.335 29.8737 37.7803 29.8737 22.2529 29.8737V14.4459H47.7412V29.8737Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M42.1299 17.7633L36.6362 22.8508L34.8349 20.8097C34.6243 20.5711 34.2615 20.5457 34.0189 20.7485L28.0845 25.7308C27.8362 25.939 27.8041 26.3087 28.0124 26.5565C28.2201 26.8042 28.5912 26.8365 28.8376 26.6283L34.3341 22.0138L36.1543 24.0763C36.259 24.1948 36.4066 24.266 36.564 24.2738C36.7265 24.2821 36.8758 24.2254 36.9919 24.1187L42.9263 18.6236C43.1637 18.4036 43.178 18.0327 42.9578 17.7956C42.7387 17.5571 42.3667 17.5436 42.1299 17.7633Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.3057 40.028C20.5654 40.028 19.1416 41.4459 19.1416 43.192C19.1416 44.9323 20.5654 46.3502 22.3057 46.3502C24.0459 46.3502 25.4639 44.9323 25.4639 43.192C25.4639 41.4459 24.0459 40.028 22.3057 40.028ZM22.3057 45.1783C21.21 45.1783 20.3135 44.2877 20.3135 43.192C20.3135 42.0905 21.21 41.1998 22.3057 41.1998C23.4014 41.1998 24.292 42.0905 24.292 43.192C24.292 44.2877 23.4014 45.1783 22.3057 45.1783Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M34.9971 40.028C33.2568 40.028 31.8389 41.4459 31.8389 43.192C31.8389 44.9323 33.2568 46.3502 34.9971 46.3502C36.7432 46.3502 38.1611 44.9323 38.1611 43.192C38.1611 41.4459 36.7432 40.028 34.9971 40.028ZM34.9971 45.1783C33.9014 45.1783 33.0107 44.2877 33.0107 43.192C33.0107 42.0905 33.9014 41.1998 34.9971 41.1998C36.0928 41.1998 36.9893 42.0905 36.9893 43.192C36.9893 44.2877 36.0928 45.1783 34.9971 45.1783Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M47.6885 40.028C45.9482 40.028 44.5303 41.4459 44.5303 43.192C44.5303 44.9323 45.9482 46.3502 47.6885 46.3502C49.4346 46.3502 50.8525 44.9323 50.8525 43.192C50.8525 41.4459 49.4346 40.028 47.6885 40.028ZM47.6885 45.1783C46.5928 45.1783 45.7021 44.2877 45.7021 43.192C45.7021 42.0905 46.5928 41.1998 47.6885 41.1998C48.79 41.1998 49.6807 42.0905 49.6807 43.192C49.6807 44.2877 48.79 45.1783 47.6885 45.1783Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M39.0928 51.36C39.0928 51.6823 38.8291 51.946 38.5068 51.946C38.501 51.946 38.501 51.946 38.4951 51.946L31.4873 51.8288C31.165 51.8229 30.9131 51.5592 30.9131 51.2428C30.9131 48.9108 32.8701 46.9948 35.2666 47.1589C37.4111 47.2936 39.0928 49.1393 39.0928 51.36Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M51.7842 51.36C51.7842 51.6823 51.5205 51.9459 51.1982 51.9459C51.1924 51.9459 51.1924 51.9459 51.1865 51.9459L44.1787 51.8288C43.8564 51.8229 43.6045 51.5592 43.6045 51.2428C43.6045 48.9166 45.5557 46.9948 47.9639 47.1588C50.1025 47.2936 51.7842 49.1393 51.7842 51.36Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M26.3955 51.3599C26.3955 51.6822 26.1318 51.9459 25.8096 51.9459C25.8037 51.9459 25.8037 51.9459 25.7979 51.9459L18.79 51.8287C18.4736 51.8228 18.2158 51.5592 18.2158 51.2428C18.2158 48.9283 20.1611 46.9947 22.5811 47.1588C24.7197 47.2935 26.3955 49.1392 26.3955 51.3599Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1285_645",
    x: 0.0999999,
    y: -0.290015,
    width: 73.8,
    height: 73.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.45
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1285_645"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1285_645",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentationIcon);
export default __webpack_public_path__ + "static/media/presentation-icon.947f2bd5a5d5d0e6cf2539e79bb893a0.svg";
export { ForwardRef as ReactComponent };